import { render, staticRenderFns } from "./NumberCircle.vue?vue&type=template&id=518ef472&scoped=true&"
import script from "./NumberCircle.vue?vue&type=script&lang=ts&"
export * from "./NumberCircle.vue?vue&type=script&lang=ts&"
import style0 from "./NumberCircle.vue?vue&type=style&index=0&id=518ef472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518ef472",
  null
  
)

export default component.exports